import { SUBSCRIPTION_TYPE } from '@/constants/subscription-type';
import { Context } from '@/context';
import { useContext } from 'react';

const useIsUserPremium = () => {
    const { state } = useContext(Context);
    const user = state?.user ?? {};

    if (!user) return false;

    return user?.subscriptionType !== SUBSCRIPTION_TYPE.FREE;
};

export default useIsUserPremium;
